module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedin),
      expression: "isLoggedin"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-container', [_c('el-header', {
    staticStyle: {
      "border-bottom": "1px solid #c5c5ca"
    }
  }, [_c('Logout')], 1), _vm._v(" "), _c('el-container', [_c('el-aside', [_c('Menu')], 1), _vm._v(" "), _c('el-main', [_c('router-view')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoggedin),
      expression: "!isLoggedin"
    }]
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1062a6bc","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = qtmw
// module chunks = 1